module.exports = __webpack_public_path__ + "img/wooden_shingles.92171cdf.jpg";